import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Problems',
    href: '#problems'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'Pricing',
    href: '#pricing'
  }, {
    name: 'Team',
    href: '#team'
  }];
  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMobileMenuOpen(false);
    const element = document.querySelector(href);
    if (element) {
      const offsetTop = element.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-cream-50/90 backdrop-blur-md shadow-sm py-4' : 'bg-transparent py-6'}`} data-id="element-85">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-86">
        <a href="#" onClick={e => {
        e.preventDefault();
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }} className="font-serif text-2xl font-medium tracking-tight text-slate-900" data-id="element-87">
          Cyberspire<span className="text-sage-300" data-id="element-88">.</span>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-89">
          {navLinks.map(link => <a key={link.name} href={link.href} onClick={e => scrollToSection(e, link.href)} className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors" data-id="element-90">
              {link.name}
            </a>)}
          <a href="#contact" onClick={e => scrollToSection(e, '#contact')} className="px-5 py-2.5 bg-slate-900 text-white text-sm font-medium rounded-full hover:bg-slate-800 transition-colors" data-id="element-91">
            Contact Us
          </a>
        </nav>

        {/* Mobile Toggle */}
        <button className="md:hidden p-2 text-slate-600" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-92">
          {mobileMenuOpen ? <X size={24} data-id="element-93" /> : <Menu size={24} data-id="element-94" />}
        </button>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-95">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-cream-50 border-t border-cream-200 overflow-hidden" data-id="element-96">
            <div className="px-6 py-4 flex flex-col gap-4" data-id="element-97">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={e => scrollToSection(e, link.href)} className="text-base font-medium text-slate-600 py-2" data-id="element-98">
                  {link.name}
                </a>)}
              <a href="#contact" onClick={e => scrollToSection(e, '#contact')} className="inline-block mt-2 px-5 py-3 bg-slate-900 text-white text-center font-medium rounded-lg" data-id="element-99">
                Contact Us
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}